import { Fragment, useState } from "react";
import LocationDialog from "./LocationDialog";
import "./styles.css";

const Location = ({ onLocationSelect, value, ...elementConfigs }) => {
  const { imgSrc, label, addressText } = elementConfigs;

  const [mapModal, setMapModal] = useState(false);

  const toggleModal = () => {
    setMapModal((prev) => !prev);
  };

  const saveLocation = (mapInformation) => {
    toggleModal();
    onLocationSelect(mapInformation);
  };

  return (
    <Fragment>
      <LocationDialog
        open={mapModal}
        value={value}
        addressText={addressText}
        onClose={toggleModal}
        onSave={saveLocation}
      />
      <div className="pin-location w-fit-content" onClick={toggleModal}>
        <img src={imgSrc || "/assets/icons/pin-location.svg"} alt="location" />
        {label}
      </div>
    </Fragment>
  );
};

export default Location;
